import { DocumentStatus } from 'DocumentStatus';
import { WizardDocumentStatus } from './aiAssistedCreationWizardTypes';

export interface ApiContentDocument {
  location: string;
  encryptedDocumentUrl?: string;
  originalFileName?: string;
  mimeType?: string;
}

export function transformApiDocuments(apiDocuments: ApiContentDocument[]): WizardDocumentStatus[] {
  return apiDocuments.map((doc) => ({
    name: doc.originalFileName || 'Unknown',
    location: doc.location,
    originalFileName: doc.originalFileName,
    timestamp: new Date().toISOString(),
    mimeType: doc.mimeType || 'application/octet-stream',
    encryptedDocumentUrl: doc.encryptedDocumentUrl,
    status: 'pending' as const,
  }));
}

export function mergeDocumentStatusResults(
  originalDocuments: WizardDocumentStatus[],
  resultDocuments: DocumentStatus[],
): WizardDocumentStatus[] {
  return resultDocuments.map((resultDoc) => {
    const originalDoc = originalDocuments.find(
      (d) => d.location === resultDoc.location || d.name === resultDoc.name,
    );
    return {
      ...resultDoc,
      encryptedDocumentUrl: originalDoc?.encryptedDocumentUrl,
      mimeType: originalDoc?.mimeType || resultDoc.mimeType,
    };
  });
}

export function buildDocumentUrlsForGeneration(selectedDocuments: WizardDocumentStatus[]) {
  return selectedDocuments.map((doc) => {
    const encryptedUrl = doc.encryptedDocumentUrl || doc.location || '';
    return {
      url: doc.location,
      encryptedDocumentUrl: encryptedUrl,
      mimeType: doc.mimeType || 'application/octet-stream',
      layoutData: undefined,
    };
  });
}

export function clearWizardLocalStorage(fundOpportunityId: string): void {
  localStorage.removeItem(`uploadedDocuments-${fundOpportunityId}`);
  localStorage.removeItem(`contentManagement-uploadedDocuments-${fundOpportunityId}`);
}
